import { validatePostalCode, validateAddress } from '../Shared/validations.js';

const validate = values => {
    const errors = {
        ...validatePostalCode(values),
        ...validateAddress(values)
    };

    return errors;
};

export default validate;
